'use client'

import { useTranslations } from 'next-intl'
import { use } from 'react'

import ViverseWorldCard from '@/components/ViverseWorldCard'
import SectionSeparator from '@/components/SectionSeparator'
import { useConfigsContext } from '@/context/ConfigsContext'
import { Room } from '@/services/cms'
import { getCardType } from '@/lib/viverse-world-card'

type UserPremiumRoomsProps = {
  premiumRoomsPromise: Promise<Room[]>
}

function UserPremiumRooms({ premiumRoomsPromise }: UserPremiumRoomsProps) {
  const t = useTranslations()
  const { store } = useConfigsContext()
  const premiumRooms = use(premiumRoomsPromise)

  if (premiumRooms.length === 0) return null

  const htcToken = store?.credentials?.htcToken

  return (
    <>
      <SectionSeparator />
      <section
        id="premium"
        data-section="profile-premium-worlds"
        className="flex scroll-mt-36 flex-col justify-between px-4 md:px-8 lg:scroll-mt-40 lg:px-18"
      >
        <h2 className="subheader-1 md:header-4 relative mb-4 font-bold md:mb-6">
          {t('profile-page.anchors.premium')}
        </h2>

        <div className="no-scrollbar w-full max-lg:overflow-scroll max-lg:scroll-smooth md:-mx-2">
          <div className="flex gap-2 md:gap-1 lg:flex-wrap lg:gap-2">
            {premiumRooms.map((room, index) => (
              <ViverseWorldCard
                className="profile-card-size"
                key={`world-card-${room.id}-${index}`}
                info={room}
                hideLiked={!htcToken}
                hidePremiumBadge={false}
                cardType={room.content_type ? getCardType(room.content_type) : 'experiences'}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default UserPremiumRooms
